module Meevo.Plugins.ResourceCategories {
    "use strict";

    /**
    * Main Section of Client 
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ResourceCategory> {

        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd:(data:any)=>any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }

        private _activeState: boolean;

        get activeState(): boolean {
            if (this.model !== undefined) {
                if (this.model.objectState === Model.ObjectStateEnum.Active) {
                    return true;
                }
            }

            return false;
        }
        capacityChanged() {
            if (this.model.capacity < 2) {
                this.model.canBeSplit = false;
            }
        }
        createSectionModelCopy(): Model.ResourceCategory {
            let item = <Model.ResourceCategory>(this.model);
            item.id = null;
            return item;
        }

        set activeState(value: boolean) {
            if (this.model !== undefined) {
                if (value) {
                    this.model.objectState = Model.ObjectStateEnum.Active;
                } else {
                    if (this.model.objectState !== Model.ObjectStateEnum.Deleted) {
                        this.model.objectState = Model.ObjectStateEnum.Inactive;
                    }
                }
            }
        }
    }

}